import { IzobrazevanjePrijavaListDto } from '../../types/IzobrazevanjePrijava/IzobrazevanjePrijavaListDto';
import { AxiosError, AxiosResponse } from "axios";
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import groupArrayOfObjectsBy from "../../utils/Common";
import Nullable from '../../types/Nullable';
import { IzobrazevanjePrijavaUporabnikType } from '../../types/Izobrazevanje/IzobrazevanjePrijavaUporabnikType';
import getApiExceptionObjectFromAxiosError from '../../utils/ProcessException';
import { FeedbackContext, Status } from '../../context/FeedbackContext';
import { useContext } from 'react';
import client from '../../services/client';

// TODO: ena funkcija, ki izvaja klice, da se ne podvaja logika za vse klice
type IzobrazevanjePrijavaUporabnikGroupedType = {
    [key: string]: IzobrazevanjePrijavaListDto[]
};

const useFetchUporabnikAktualno = () => {
    return useQuery<IzobrazevanjePrijavaUporabnikGroupedType, AxiosError>(["izobrazevanjeAktualno"], async () => {
        try {
            let prijaveAll = (await client.get("izobrazevanje/aktualno")).data;
            let prijaveGrouped = groupArrayOfObjectsBy(prijaveAll, "izobrazevanjeTipNaziv");
            return prijaveGrouped;
        }
        catch (error) {
            // TODO: kiri - se da tu narediti kaj generičnega (getApiExceptionObjectFromAxiosError)
            return Promise.reject(error);
        }
    });
};

const useFetchUporabnikMojePrijave = () => {
    return useQuery<IzobrazevanjePrijavaUporabnikGroupedType, AxiosError>(["izobrazevanjePrijave"], async () => {
        try {
            let prijaveAll = (await client.get("izobrazevanje/mojePrijave")).data;
            let prijaveGrouped = groupArrayOfObjectsBy(prijaveAll, "izobrazevanjeTipNaziv");
            return prijaveGrouped;
        }
        catch (error) {
            // TODO: kiri - se da tu narediti kaj generičnega (getApiExceptionObjectFromAxiosError)
            return Promise.reject(error);
        }

    })
};

const useFetchUporabnikZakljuceno = () => {
    return useQuery<IzobrazevanjePrijavaUporabnikGroupedType, AxiosError>(["izobrazevanjeZakljuceno"], async () => {
        try {
            let prijaveAll = (await client.get("izobrazevanje/zakljuceno")).data;
            let prijaveGrouped = groupArrayOfObjectsBy(prijaveAll, "izobrazevanjeTipNaziv");
            return prijaveGrouped;
        }
        catch (error) {
            // TODO: kiri - se da tu narediti kaj generičnega (getApiExceptionObjectFromAxiosError)
            return Promise.reject(error);
        }
    });
};

const useFetchIzobrazevanjeJavno = () => {
    return useQuery<IzobrazevanjePrijavaUporabnikGroupedType, AxiosError>(["izobrazevanjeJavno"], async () => {
        try {
            let prijaveAll = (await client.get("izobrazevanje/javno")).data;
            console.log("prijaveAll", prijaveAll);
            let prijaveGrouped = groupArrayOfObjectsBy(prijaveAll, "izobrazevanjeTipNaziv");
            console.log("prijaveGrouped", prijaveGrouped);
            return prijaveGrouped;
        }
        catch (error) {
            // TODO: kiri - se da tu narediti kaj generičnega (getApiExceptionObjectFromAxiosError)
            return Promise.reject(error);
        }
    });
};

const useFetchPrijavaByUporabnikIzobrazevanjeId = (izobrazevanjeId: Nullable<number>) => {
    return useQuery<IzobrazevanjePrijavaListDto, AxiosError>(["izobrazevanjePrijave", izobrazevanjeId], async () => {
        try {
            return (await client.get(`izobrazevanjePrijava/izobrazevanje/${izobrazevanjeId}`)).data;
        }
        catch (error) {
            return Promise.reject(error);
        }
    });
};

const useFetchPrijavaByIzobrazevanjeId = (izobrazevanjeId: number) => {
    return useQuery<IzobrazevanjePrijavaUporabnikType[], AxiosError>(["izobrazevanjePrijaveByIzobrazevanjeId", izobrazevanjeId], async () => {
        try {
            return (await client.get(`izobrazevanjePrijava/${izobrazevanjeId}`)).data;
        }
        catch (error) {
            return Promise.reject(error);
        }
    });
};

const useFetchPrijavaByIzobrazevanjeIdCsv = (izobrazevanjeId: number) => {
    const { displayFeedback } = useContext(FeedbackContext)
    return useQuery<Blob, AxiosError>([izobrazevanjeId], async () => {
        try {
            return (await client.get(`izobrazevanjePrijava/exportCsv/${izobrazevanjeId}`, { responseType: 'blob' })).data;
        }
        catch (error) {
            return Promise.reject(error);
        }
    }, {
        enabled: false,
        retry: false,
        onSuccess: (data) => {
            const url = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'izobrazevanjePrijave.csv');
            document.body.appendChild(link);
            link.click();
        },
        onError: (err) => {
            let errMsg = "Prišlo je do napake pri izvozu prijav v excel."
            let apiException = getApiExceptionObjectFromAxiosError(err);
            if (apiException?.Message)
                errMsg = apiException.Message;

            if (displayFeedback)
                displayFeedback(errMsg, Status.ERROR)
        },
    });
};

const useAddIzobrazevanjePrijava = () => {
    const queryClient = useQueryClient();
    return useMutation<AxiosResponse, AxiosError, number>(async (izobrazevanjeId) => {
        try {
            return (await client.post(`izobrazevanjePrijava/prijava/${izobrazevanjeId}`, { izobrazevanjeId: izobrazevanjeId }));
        }
        catch (error) {
            return Promise.reject(error);
        }
    }, {
        onSuccess: () => {
            queryClient.invalidateQueries(["izobrazevanjePrijave"]);
        },
        onError: (err) => {
            // TODO?: mogoče se lahko tu kaj poenoti za exception handling...
        }
    });
};

const useUpdateIzobrazevanjePrijava = () => {
    const queryClient = useQueryClient();
    return useMutation<AxiosResponse, AxiosError, number>(async (izobrazevanjePrijavaId) => {
        try {
            return (await client.put(`izobrazevanjePrijava/odjava/${izobrazevanjePrijavaId}`, { izobrazevanjePrijavaId: izobrazevanjePrijavaId }));
        }
        catch (error) {
            return Promise.reject(error);
        }
    }, {
        onSuccess: (_, i) => {
            queryClient.invalidateQueries(["izobrazevanjePrijave"]);
        },
        onError: (err) => {
            // TODO?: mogoče se lahko tu kaj poenoti za exception handling...
        }
    });
};

export {
    useFetchUporabnikAktualno,
    useFetchUporabnikMojePrijave,
    useFetchUporabnikZakljuceno,
    useFetchIzobrazevanjeJavno,
    useFetchPrijavaByUporabnikIzobrazevanjeId,
    useFetchPrijavaByIzobrazevanjeId,
    useFetchPrijavaByIzobrazevanjeIdCsv,
    useAddIzobrazevanjePrijava,
    useUpdateIzobrazevanjePrijava
};

export type { IzobrazevanjePrijavaUporabnikGroupedType };